/**
 * created by hezq on 2019-10-24
 *
 * description： 项目js工具
 *
 */

import doT from 'dot';
import Cookies from 'js-cookie';

const config = require('./config.js');

let utils = {
	/**
	 * description： 页面跳转,带上时间戳
	 * @param {String} path 相对路径
	 * @param {Object} params url带的参数
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	href(path, params) {
		if (!params) {
			window.location.href = `/${config.PROJECT_NAME}/pages/${path}?${`_t=${new Date().getTime()}`}`;
		} else {
			if (typeof params === 'object') {
				let str = '';

				for (let key in params) {
					str += key + '=' + params[key] + '&';
				}
				str += '_t=' + new Date().getTime();
				window.location.href = `/${config.PROJECT_NAME}/pages/${path}?${str}`;
			} else {
				throw new Error('parameter error:params');
			}

		}
	},

	/**
	 * description： 新打开页面跳转,带上时间戳
	 * @param {String} path 相对路径
	 * @param {Object} params url带的参数
	 *
	 * created by zhouzt on 2019-09-04
	 *
	 */
	open(path, params) {
		if (!params) {
			window.open(`/${config.PROJECT_NAME}/pages/${path}?${`_t=${new Date().getTime()}`}`);
		} else {
			if (typeof params === 'object') {
				let str = '';

				for (let key in params) {
					str += key + '=' + params[key] + '&';
				}
				str += '_t=' + new Date().getTime();
				window.open(`/${config.PROJECT_NAME}/pages/${path}?${str}`);
			} else {
				throw new Error('parameter error:params');
			}

		}
	},

	/**
	 * description： dot模版里地址替换
	 * @param {String} html dot模版的html
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	replacePath(html) {
		let str = html.replace(/\$\$_STATICPATH_\$\$/g, '../../static/6f9311/assets');

		str = str.replace(/<!--.*?-->/g, '');
		return str;
	},

	/**
	 * description： 给data对象绑定this值,在dot模版里事件就可以这样写-that.xxx()
	 * @param {Object} data 类里构造函数的参数
	 * @param {Object} that 类的实例
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	bindThis(data, that) {
		if (typeof data === 'object') {
			for (let key in data) {
				that[key] = data[key];
			}
		}
	},

	/**
	 * description： 获取字符长度
	 * @param {String} str 字符串
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	getLen(str) {
		//先把中文替换成两个字节的英文，在计算长度
		return str.replace(/[\u0391-\uFFE5]/g, 'aa').length;
	},

	/**
	 * description： 获取url的相对路径，假如当前 Url 是 http// www.liangshunet.com/pub/item.aspx?t=osw7，则截取到的相对路径为：/pub/item.aspx。
	 * @return {String} 相对地址
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	getUrlRelativePath() {
		let url = document.location.toString();
		let arrUrl = url.split('//');
		let start = arrUrl[1].indexOf('/');
		let relUrl = arrUrl[1].substring(start);


		if (relUrl.indexOf('?') != -1) {
			relUrl = relUrl.split('?')[0];
		}


		return relUrl;
	},

	/**
   * description: 刷新token，刷新数据
   * @param {Object} data 刷新返回值
   *
   * created by hezq on 2021-04-16
   *
   */
	refresh (data) {
		// 定义 cookie 相关时间
		const accessTime = new Date(new Date().getTime() + data.access_time * 1000)
		const refreshTime = new Date(new Date().getTime() + data.refresh_time * 1000)
		const lastRefreshTime = new Date().getTime()

		// 更新 cookie
		Cookies.set(`${config.PLAT}${config.DOMAIN}.access_token`, data.access_token, {
			expires: accessTime,
			domain: config.DOMAIN
		})
		Cookies.set(`${config.PLAT}${config.DOMAIN}.access_time`, data.access_time, {
			expires: accessTime,
			domain: config.DOMAIN
		})
		Cookies.set(`${config.PLAT}${config.DOMAIN}.refresh_token`, data.refresh_token, {
			expires: refreshTime,
			domain: config.DOMAIN
		})
		Cookies.set(`${config.PLAT}${config.DOMAIN}.refresh_time`, data.refresh_time, {
			expires: refreshTime,
			domain: config.DOMAIN
		})
		Cookies.set(`${config.PLAT}${config.DOMAIN}.last_refresh_time`, lastRefreshTime, {
			expires: refreshTime,
			domain: config.DOMAIN
		})

		const userid = Cookies.get(`${config.PLAT}${config.DOMAIN}.userid`, {
			domain: config.DOMAIN
		})

		Cookies.set(`${config.PLAT}${config.DOMAIN}.userid`, userid, {
			expires: refreshTime,
			domain: config.DOMAIN
		})
	},

	/**
	 * description： 退出系统,清除cookie相关内容,跳回到登录页
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	loginOut() {
		// 清除一些cookie
		Cookies.remove(config.PLAT + config.DOMAIN, {
			domain: config.DOMAIN
		});
		Cookies.remove(config.PLAT + config.DOMAIN + '.access_token', {
			domain: config.DOMAIN
		});
		Cookies.remove(config.PLAT + config.DOMAIN + '.access_time', {
			domain: config.DOMAIN
		});
		Cookies.remove(config.PLAT + config.DOMAIN + '.refresh_token', {
			domain: config.DOMAIN
		});
		Cookies.remove(config.PLAT + config.DOMAIN + '.refresh_time', {
			domain: config.DOMAIN
		});
		Cookies.remove(config.PLAT + config.DOMAIN + '.last_refresh_time', {
			domain: config.DOMAIN
		});
		Cookies.remove(config.PLAT + config.DOMAIN + '.userid', {
			domain: config.DOMAIN
		});

		// 移除本地缓存
		tools.store.delLS('user');
		tools.store.delLS('btnAuths');

		// 跳转到登录页
		window.location.href = config.BS_PATH;
	},

	/**
	 * 获取相对路径
	 * @param {Number} level 相对pages几级目录
	 *
	 * * created by hezq on 2019-09-09
	 */
	getDpath(level) {
		let el = '../';

		level = level || 1;

		return utils.repeat(el, level - 1);
	},

	/**
	 * description： 重复字符串
	 * @param {String} str 需要重复字符串
	 * @param {Number} num 重复次数
	 *
	 * created by zhouzt on 2019-09-04
	 *
	 */
	repeat(str, num) {
		let newStr = '';

		for (let i = 0; i < num; i++) {
			newStr += str;
		}

		return newStr;
	},

	/**
	 * description： 二次确认提示
	 * @param {Object} options 参数配置
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	confirm(options) {
		// 先关闭页面上的消息提示框
		utils.closeAllAlert();

		// 定义默认参数配置
		let defaultOptions = {
			title: '提示', // 标题
			zIndex: 1000,  // 弹出窗的层级
			message: '', // 提示信息，不带输入框时必传
			type: 'info', // 确认提示框类型，默认info-二次确认提示，可选input-输入框，textarea-文本域，tip-信息提示
			placeholder: '请输入', // 输入框占位符，带输入框时有效
			value: '', // 输入值，带输入框时有效
			maxlength: '', // 限制字段
			checkText:'', // 提示文字
			isCheck: true, // 是否需要校验
			isClose:true,// 是否需要关闭弹窗
			success: function() {}, // 确认回调函数
			cancel: function() {}, // 取消回调函数
		};

		// 组装参数配置
		options = Object.assign(defaultOptions, options);

		// 定义确认框的html
		let html_confirm = '';

		// 判断是否带input输入框
		if(options.type === 'input') {
			// 定义带有input输入框的html
			html_confirm = '<div id="confirmWin">'
								+'<div class="spzx_mask" style="z-index: {{=it.zIndex - 1}}"></div>'
								+'<div class="spzx_sure_messagebox Messagebox bfff bs4c000" style="z-index: {{=it.zIndex}}" >'
									+'<h5 class="messagebox_tit">{{=it.title}}<i class="iconfont spzx-icon-close closeBtn"></i></h5>'
									+'<div class="inputbox">'
										+'<input id="confirmValue" class="form-control" placeholder="{{=it.placeholder}}" value="{{=it.value}}" />'
									+'</div>'
									+'<div class="spzx_buttons">'
										+'<labal class="sureOk_label">'
											+'<a href="javascript:;" class="spzx_button agree lgc_glass" id="sureOk">确认</a>'
										+'</labal>'
										+'<a href="javascript:;" class="spzx_button close lgc_gray closeBtn">取消</a>'
									+'</div>'
								+'</div>'
							+'</div>';
		} else if(options.type === 'textarea') {
			// 定义带有textarea输入框的html
			html_confirm = '<div id="confirmWin">'
								+'<div class="spzx_mask" style="z-index: {{=it.zIndex - 1}}"></div>'
								+'<div class="spzx_sure_messagebox Messagebox bfff bs4c000" style="z-index: {{=it.zIndex}}" >'
									+'<h5 class="messagebox_tit">{{=it.title}}<i class="iconfont spzx-icon-close closeBtn"></i></h5>'
									+'<div class="textareabox">'
										+'<textarea id="confirmValue" class="" placeholder="{{=it.placeholder}}" value="{{=it.value}}" rows="4">{{=it.value}}</textarea>'
									+'</div>'
									+'<div class="spzx_buttons">'
										+'<labal class="sureOk_label">'
											+'<a href="javascript:;" class="spzx_button agree lgc_glass" id="sureOk">确认</a>'
										+'</labal>'
										+'<a href="javascript:;" class="spzx_button close lgc_gray closeBtn">取消</a>'
									+'</div>'
								+'</div>'
							+'</div>';
		} else if(options.type === 'tip'){
			html_confirm = '<div id="confirmWin">'
								+'<div class="spzx_mask" style="z-index: {{=it.zIndex - 1}}"></div>'
								+'<div class="spzx_sure_messagebox Messagebox bfff bs4c000" style="z-index: {{=it.zIndex}}" >'
									+'<h5 class="messagebox_tit">{{=it.title}}<i class="iconfont spzx-icon-close closeBtn"></i></h5>'
									+'<p>{{=it.message}}</p>'
									+'<div class="spzx_buttons">'
										+'<a href="javascript:;" class="spzx_button close lgc_gray closeBtn">关闭</a>'
									+'</div>'
								+'</div>'
							+'</div>';
		}else {
			// 判断必传参数是否完整
			if(options.message === ''){
				throw new Error('Lack of required parameter: message');
			}

			// 定义确认框的html
			html_confirm = '<div id="confirmWin">'
								+'<div class="spzx_mask" style="z-index: {{=it.zIndex - 1}}"></div>'
								+'<div class="spzx_sure_messagebox Messagebox bfff bs4c000" style="z-index: {{=it.zIndex}};">'
									+'<h5 class="messagebox_tit">{{=it.title}}<i class="iconfont spzx-icon-close closeBtn"></i></h5>'
									+'<p>{{=it.message}}</p>'
									+'<div class="spzx_buttons">'
										+'<labal class="sureOk_label">'
											+'<a href="javascript:;" class="spzx_button agree lgc_glass" id="sureOk">确认</a>'
										+'</labal>'
										+'<a href="javascript:;" class="spzx_button close lgc_gray closeBtn">取消</a>'
									+'</div>'
								+'</div>'
							+'</div>';
		}

		// 渲染dot模板
		let confirmObj = $(doT.template(html_confirm)(options));

		// 将渲染好的html添加到body
		top.$('body').append(confirmObj);

		// 输入框控制
		if(options.type === 'textarea') {
			// 实时控制错误提示
			confirmObj.find('#confirmValue').on('input',function() {
				// 获取输入框的值
				let value = $('#confirmValue').val().trim();

				if(value.length >0 && (value.length <= options.maxlength || !options.maxlength)) {
					// 先移除移除错误提示
					$('#confirmTips').remove();
				}
			});
		}

		// 绑定确认事件
		confirmObj.find('#sureOk').click(function() {
			// 先移除移除错误提示
			$('#confirmTips').remove();

			// 判断是否带input输入框
			if(options.type === 'input' || options.type === 'textarea') {
				// 获取输入框的值
				let value = $('#confirmValue').val().trim();

				// 判断是否有输入值
				if(value === '' && options.isCheck) {
					// 提示错误
					$('#confirmValue').parent().append('<span id="confirmTips" class="cf00 validate-tips">' + options.placeholder + '</span>');
					return;
				}
				// 判断是否有输入值
				if(options.maxlength && value.length > options.maxlength) {
					// 提示错误
					$('#confirmValue').parent().append('<span id="confirmTips" class="cf00 validate-tips">' + options.checkText + '</span>');
					return;
				}

				// 返回用户输入的值
				options.success(value);
			} else {
				// 执行确认回调函数
				options.success();
			}

			// 是否关闭确认框
			if(options.isClose) {
				utils.confirmClose();
			}


		});
		// 绑定取消事件
		confirmObj.find('.closeBtn').click(function() {
			// 关闭确认框
			utils.confirmClose();
		});
		confirmObj.find('.close').click(function() {
			// 执行取消回调函数
			options.cancel();
		});
		// 根据实际浏览窗口高度，设置背景遮罩层的高度
		confirmObj.find('.spzx_mask').height($(top.document).height());
	},

	/**
	 * description： 关闭确认框
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	confirmClose() {
		// 获取确认框
		let confirmDialog = $('#confirmWin');
		// 移除确认框

		confirmDialog.remove();
	},

	/**
	 * description： 消息提示窗
	 * @param {Object} options 参数配置
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	alert(options) {
		// 关闭全部弹窗
		utils.closeAllAlert();
		// 定义默认参数配置
		let defaultOptions = {
			message: '', // 提示信息，必传
			type: '', // 提示框类型，必传：success-成功，warning-警告，error-失败
			duration: 3000, // 单位毫秒，默认3秒后关闭消息提示窗
		};

		// 组装参数配置
		options = Object.assign(defaultOptions, options);

		// 判断必传参数是否完整
		if(options.message === '' || options.type === '') {
			throw new Error('Lack of required parameters: type or message');
		}

		// 根据类型定义提示框样式
		let type_class = '',
			type_icon = '';

		switch(options.type) {
		case 'success':
			type_class = 'spzx_toast_sure';
			type_icon = 'spzx-icon-zhengque';
			break;
		case 'warning':
			type_class = 'spzx_toast_warn';
			type_icon = 'spzx-icon-tishi';
			break;
		case 'error':
			type_class = 'spzx_toast_error';
			type_icon = 'spzx-icon-cuowu';
			break;
		default:
			break;
		}

		// 定义提示框的html
		var html_alert = '<div class="spzx_fixtoast ' + type_class + '"><p><i class="iconfont ' + type_icon + '"></i>{{=it.message}}<i class="iconfont spzx-icon-close fr alert_close_icon" style="cursor: pointer"></i></p></div>';

		// 将渲染好的html添加到body
		top.$('body').append(doT.template(html_alert)(options));

		// 点击关闭图标
		top.$('.spzx_fixtoast').on('click', '.alert_close_icon',function(e) {
			$(this).parents('.spzx_fixtoast').remove();
		});
	},

	/**
	 * description： 关闭页面上所有的提示框
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	closeAllAlert() {
		if(top.$('.spzx_fixtoast').length > 0) {
			top.$('.spzx_fixtoast').remove();
		}
	},

	/**
	 * description： 关闭页面上所有的二次确认框
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	closeAllConfim() {
		if(top.$('.spzx_sure_messagebox').length > 0) {
			top.$('.spzx_sure_messagebox').remove();
			top.$('#confirmWin').remove();
		}
	},

	/**
	 * description： 加载表格loading效果
	 * @param {String} id #id或.class
	 *
	 * created by hezq on 2019年03月28日
	 *
	 */
	tableLoading(id) {
		// 判断是否已处于加载状态，防止重复加载
		if($(id).hasClass('table_loading')) {
			return;
		} else {
			$(id).addClass('table_loading');
			$(id).append('<span class=\'begin\'><i></i></span>');
		}
	},

	/**
	 * description： 关闭表格loading效果
	 * @param {String} id #id或.class
	 *
	 * created by hezq on 2019年03月28日
	 *
	 */
	unTableLoading(id) {
		$(id).removeClass('table_loading');
		$(id).find('.begin').remove();
	},

	/**
	 * description： 加载按钮loading效果
	 * @param {String} id #id或.class
	 *
	 * created by panjm on 2019-09-10
	 *
	 */
	btnLoading(id) {
		// 判断是否已处于加载状态，防止重复加载
		if($(id).hasClass('btn_loading')) {
			return;
		} else {
			$(id).addClass('btn_loading');
			$(id).append('<span class=\'begin\'><i></i></span>');
		}
	},

	/**
	 * description： 关闭按钮loading效果
	 * @param {String} id #id或.class
	 *
	 * created by panjm on 2019-09-10
	 *
	 */
	unBtnLoading(id) {
		$(id).removeClass('btn_loading');
		$(id).find('.begin').remove();
	},

	/**
	 * description： 页面loading效果
	 * @param {String} id #id或.class
	 *
	 * created by panjm on 2019-09-11
	 *
	 */
	pageLoading(){
		if($('body').find('#page_mask').length > 0 && $('body').find('#page_loading').length > 0) {
			return;
		} else {
			var loadingHtml = '<div class="page_mask" id="page_mask"></div>'
						+ '<div class="page_loading" id="page_loading"></div>';

			$('body').append(loadingHtml);
		}
	},

	/**
	 * description： 关闭页面loading效果
	 * @param {String} id #id或.class
	 *
	 * created by panjm on 2019-09-11
	 *
	 */
	unPageLoading() {
		if($('body').find('#page_mask').length > 0 && $('body').find('#page_loading').length > 0) {
			$('body').find('#page_mask').remove();
			$('body').find('#page_loading').remove();
		}
	},

	/**
	 * description： 获取当前时间
	 *
	 * created by liubo on 2019-09-11
	 *
	 */
	getNowFormatDate() {
		var date = new Date();
		var seperator1 = '-';
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var strDate = date.getDate();

		if (month >= 1 && month <= 9) {
			month = '0' + month;
		}
		if (strDate >= 0 && strDate <= 9) {
			strDate = '0' + strDate;
		}
		var currentdate = year + seperator1 + month + seperator1 + strDate;

		return currentdate;
	},

	/**
	 * description： 获取明天的时间
	 *
	 * created by liubo on 2019-09-11
	 *
	 */
	getTomorrowFormatDate() {
		var date = new Date();

		date.setTime(date.getTime() + 24*60*60*1000);
		var seperator1 = '-';
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var strDate = date.getDate();

		if (month >= 1 && month <= 9) {
			month = '0' + month;
		}
		if (strDate >= 0 && strDate <= 9) {
			strDate = '0' + strDate;
		}
		var currentdate = year + seperator1 + month + seperator1 + strDate;

		return currentdate;
	},

	/**
	 * description： 比较两个时间的大小
	 *
	 * created by liubo on 2019-09-11
	 *
	 */
	compareDate(date1, date2) {
		if(date1&&date2){
			var date1 = new Date(date1);
			var date2 = new Date(date2);

			if (date1.getTime() > date2.getTime()) {
				return true;
			} else {
				return false;
			}
		}else{
			return true;
		}
	},

	/**
	 * description： 数字第一位加0或者减0
	 *
	 * created by huyy on 2019-09-17
	 *
	 */
	addZero(num) {
		if(num >= 1 && num <= 9) {
			 num = '0' + num;
		}
		return num;
	},

	/**
	 * description: 防抖函数
	 * @param {Function} fn 函数
	 * @param {Number} delay 延时
	 *
	 * created by zhouzt on 2019-09-10 11:52:33
	 */
	debounce(fn, delay = 500) {
		let timeout = null; // 创建一个标记用来存放定时器的返回值

		return function () {
			clearTimeout(timeout); // 每当用户输入的时候把前一个 setTimeout clear 掉
			timeout = setTimeout(() => { // 然后又创建一个新的 setTimeout, 这样就能保证输入字符后的 interval 间隔内如果还有字符输入的话，就不会执行 fn 函数
				fn.apply(this, arguments);
			}, delay);
		};
	},

	/**
	 * description： 校验扩展，提示效果处理
	 * @param {String} id  包含所需验证表单的容器选择器
	 * @param {Object} map 验证规则
	 * @param {String} position  添加验证错误提示信息的父级容器选择器（该父级元素的position必须为relative）
	 * @param {String} scrollContainer 指定的滚动容器
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	formValidate(id, map, position, scrollContainer) {
		return utils.validate(id, map, position, function(obj, position, message) {

			// 错误提示显示位置
			let tipsParent = '';

			if(position) {
				tipsParent = $(obj).parents(position);
			} else {
				tipsParent = $(obj).parent();
			}

			// 设为相对定位
			tipsParent.css('position', 'relative');

			// 先进行表单校验效果去除（必须，否侧会添加多次）
			tipsParent.find('.validate-tips').remove();
			// 在此自定义提示方式
			let tipsHtml = '';
			let firstTips = null; 	// 第一个错误提示
			let scrollTo = 0; 		// 第一个错误提示距离页面顶部的距离

			tipsHtml = '<span class="validate-tips">' + message + '</span>';
			tipsParent.append(tipsHtml);
			// 页面滚动到第一个错误提示所在位置，并且当该错误提示为文本输入框时
			if($('.validate-tips').length > 0) {
				firstTips = $(id).find('.validate-tips').eq(0);

				// 光标聚焦当前可输入框
				if(firstTips.parent().find('input[type="text"]') && firstTips.parent().find('input[type="text"]').length > 0) {
					firstTips.parent().find('input').focus();
				} else if(firstTips.parent().find('textarea')){
					firstTips.parent().find('textarea').focus();
				} else {
					scrollTo = firstTips.offset().top - $(obj).height();

					// 判断是否有指定的滚动容器
					if(scrollContainer) {
						// 使用stop()阻止动画反复触发，否则会出现页面短暂一段时间无法进行滚动的现象
						$(scrollContainer).stop().animate({
							scrollTop: scrollTo - '40' + 'px'
						}, 500);
					} else {
						// 使用stop()阻止动画反复触发，否则会出现页面短暂一段时间无法进行滚动的现象
						$('html,body').stop().animate({
							scrollTop: scrollTo - '40' + 'px'
						}, 500);
					}
				}
			}

		}, function(obj, position) {
			// 错误提示显示位置
			let tipsParent = '';

			if(position) {
				tipsParent = $(obj).parents(position);
			} else {
				tipsParent = $(obj).parents('td').length > 0 ? $(obj).parents('td') : $(obj).parent();
			}
			// 验证通过回调函数
			tipsParent.find('.validate-tips').remove(); // 表单校验效果去除
		});
	},

	/**
	 * description： 校验扩展，提示效果处理
	 * @param {String} id  包含所需验证表单的容器选择器
	 * @param {Object} map 验证规则
	 * @param {String} position  添加验证错误提示信息的父级容器选择器（该父级元素的position必须为relative）
	 * @param {String} scrollContainer 指定的滚动容器
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	inputValidate(id, map, position, scrollContainer) {
		return utils.validateOne(id, map, position, function(obj, position, message) {

			// 错误提示显示位置
			let tipsParent = '';

			if(position) {
				tipsParent = $(obj).parents(position);
			} else {
				tipsParent = $(obj).parent();
			}

			// 设为相对定位
			tipsParent.css('position', 'relative');

			// 先进行表单校验效果去除（必须，否侧会添加多次）
			tipsParent.find('.validate-tips').remove();
			// 在此自定义提示方式
			let tipsHtml = '';
			let firstTips = null; 	// 第一个错误提示
			let scrollTo = 0; 		// 第一个错误提示距离页面顶部的距离

			tipsHtml = '<span class="validate-tips">' + message + '</span>';
			tipsParent.append(tipsHtml);
			// 页面滚动到第一个错误提示所在位置，并且当该错误提示为文本输入框时
			if($('.validate-tips').length > 0) {
				firstTips = $('.validate-tips').eq(0);
				// 光标聚焦当前可输入框
				if(firstTips.parent().find('input[type="text"]') && firstTips.parent().find('input[type="text"]').length > 0) {
					firstTips.parent().find('input').focus();
				} else if(firstTips.parent().find('textarea')){
					firstTips.parent().find('textarea').focus();
				} else {
					scrollTo = firstTips.offset().top - $(obj).height();

					// 判断是否有指定的滚动容器
					if(scrollContainer) {
						// 使用stop()阻止动画反复触发，否则会出现页面短暂一段时间无法进行滚动的现象
						$(scrollContainer).stop().animate({
							scrollTop: scrollTo - '40' + 'px'
						}, 500);
					} else {
						// 使用stop()阻止动画反复触发，否则会出现页面短暂一段时间无法进行滚动的现象
						$('html,body').stop().animate({
							scrollTop: scrollTo - '40' + 'px'
						}, 500);
					}
				}
			}

		}, function(obj, position) {
			// 错误提示显示位置
			let tipsParent = '';

			if(position) {
				tipsParent = $(obj).parents(position);
			} else {
				tipsParent = $(obj).parents('td').length > 0 ? $(obj).parents('td') : $(obj).parent();
			}
			// 验证通过回调函数
			tipsParent.find('.validate-tips').remove(); // 表单校验效果去除
		});
	},

	/**
	 * 校验值
	 * @param id 	  所有待验证项所处的容器
	 * @params map 	  验证规则对象
	 * @params error 验证失败回调函数
	 * @params error 验证通过回调函数
	 * @return	 	  验证通过返回true,否则返回false
	 */
	validate(id, map, position, error, success) {
		let flag = true;
		let showError = true;

		$(id).find('input,select,textarea,[type=\'radio\']:checked,[type=\'checkbox\']:checked').each(function() {
			let options = map[this.name]; //配置
			let errorMsg = ''; // 错误提示信息

			//如果此文本需要校验
			if(options) {
				// 如果存在自定义验证函数
				if(options.validateFn) {
					// 先校验输入框是否输入了字符串
					if(!$(this).val().trim()) {
						flag = false;
						errorMsg = options.tips;
					} else if(options.validateFn($(this)) == false) { // 自定义的校验规则
						flag = false;
						errorMsg = options.validateTips ? options.validateTips : options.tips;
					}
				} else {
					let _input = $(this);
					let val;

					if(_input.is('select')) {
						val = _input.find('option:selected').val();
					} else if(_input.is('[type=\'radio\']')) {
						val = $('[name=\'' + this.name + '\']:checked').val();
					} else if(_input.is('[type=\'checkbox\']')) {
						val = [];
						$('[name=\'' + this.name + '\']:checked').each(function() {
							val.push(this.value);
						});
					} else {
						val = _input.val().trim();
					}
					//校验
					errorMsg = utils.checkInput(val, options);
					if(errorMsg != '' && errorMsg) {
						flag = false;
					}
				}
				// 判断验证是否通过
				if(flag) {
					if(success) { // 执行成功回调函数
						success($(this), position);
					}
				} else {
					//存在错误数据
					if(error && showError) {
						if(error($(this), position, errorMsg) == false) {
							showError = false;
						}
					}
				}
			}
		});
		return flag;
	},

	/**
	 * 校验值
	 * @param id 	  所有待验证项所处的容器
	 * @params map 	  验证规则对象
	 * @params error 验证失败回调函数
	 * @params error 验证通过回调函数
	 * @return	 	  验证通过返回true,否则返回false
	 */
	validateOne(id, map, position, error, success) {
		let flag = true;
		let showError = true;

		$(id).each(function() {
			let options = map[this.name]; //配置
			let errorMsg = ''; // 错误提示信息

			//如果此文本需要校验
			if(options) {
				// 如果存在自定义验证函数
				if(options.validateFn) {
					// 先校验输入框是否输入了字符串
					if(!$(this).val().trim()) {
						flag = false;
						errorMsg = options.tips;
					} else if(options.validateFn($(this)) == false) { // 自定义的校验规则
						flag = false;
						errorMsg = options.validateTips ? options.validateTips : options.tips;
					}
				} else {
					let _input = $(this);
					let val;

					if(_input.is('select')) {
						val = _input.find('option:selected').val();
					} else if(_input.is('[type=\'radio\']')) {
						val = $('[name=\'' + this.name + '\']:checked').val();
					} else if(_input.is('[type=\'checkbox\']')) {
						val = [];
						$('[name=\'' + this.name + '\']:checked').each(function() {
							val.push(this.value);
						});
					} else {
						val = _input.val().trim();
					}
					//校验
					errorMsg = utils.checkInput(val, options);
					if(errorMsg != '' && errorMsg) {
						flag = false;
					}
				}
				// 判断验证是否通过
				if(flag) {
					if(success) { // 执行成功回调函数
						success($(this), position);
					}
				} else {
					//存在错误数据
					if(error && showError) {
						if(error($(this), position, errorMsg) == false) {
							showError = false;
						}
					}
				}
			}
		});
		return flag;
	},

	/**
	 * 校验input输入框的值
	 */
	checkInput(val, options) {
		options.type = options.type || 'text';
		if(options.isRequire == 1 || options.isRequire == true) {
			if(!val || val === ' ' || val.length === 0) {
				return options.tips || '请输入' + options.name;
			}
		}
		if(val) {
			//判断是字符还是数字
			if(options.type == 'text') {
				// let len = utils.getLen(val);
				let len = val.length;
				//未选择数据 AND 且设置校验最小长度 AND 当前值的长度小于最小长度

				if(options.minlen && len < options.minlen) {
					return options.name + '长度不能小于' + options.minlen;
				}
				if(options.maxlen && options.maxlen != 0 && len > options.maxlen) {
					return options.name + '长度不能大于' + options.maxlen;
				}
			} else if(options.type == 'number') {
				if(isNaN(val)) {
					return options.name + '只能为数字';
				}
				val = Number(val);
				if(options.min && val < options.min) {
					return options.name + '不能小于' + options.min;
				}
				if(options.max && val > options.max) {
					return options.name + '不能大于' + options.max;
				}
				if(options.isPositive == true && val <= 0) { // 正数（大于0的数）
					return options.name + '必须大于0';
				}
				if(options.dec) {
					/**
					 * 步骤一：计算出10的（小数位+1）次幂，如1位小数100，2位小数1000,3位小数10000
					 * 步骤二：把值乘以（步骤一的值）进行整数化，再取模（取余数）
					 * 步骤三：步骤2的余数不等于0，说明超过了options.dec设置的长度
					 * ############################
					 * 样列：以2.101校验为例子,校验2位小数（options.dec == 2）
					 * 步骤一：得出值1000
					 * 步骤二：线的出值2101，再取模（取余数）得出1
					 * 步骤三：步骤二的值不为0，则小数位不一致
					 *
					 */
					let dec = parseInt((Math.pow(10, options.dec + 1) * val).toFixed(0)) % 10; //算出小数位

					if(dec != 0) {
						return options.name + '小数位长度不能大于' + options.dec;
					}
				}
			} else if(options.type == 'integer') {
				if(!utils.isInteger(val)) {
					return options.name + '必须为整数';
				}
				val = Number(val);
				if(options.min && val < options.min) {
					return options.name + '不能小于' + options.min;
				}
				if(options.max && val > options.max) {
					return options.name + '不能大于' + options.max;
				}
			} else {
				// console.log('无法找到[' + options.name + ']的数据类型');
			}
			return '';
		}
	},

	/**
	 * description： 将对下所有form的文本序列化
	 * @param {String} id form的id
	 * @return {Object} {Object} json数组
	 *
	 * created by panjm on 2019-08-28
	 *
	 */
	serialize(id) {
		let map = {};

		$(id).find('input[type=\'text\'],input[type=\'password\'],input[type=\'hidden\'],select,textarea,input[type=\'radio\']:checked,input[type=\'checkbox\']:checked').each(function() {
			let _input = $(this);
			// let name = this.name;
			let val;

			if(_input.is('select')) {
				val = _input.find('option:selected').val();
			} else if(_input.is('[type=\'radio\']')) {
				val = $('[name=\'' + this.name + '\']:checked').val();
			} else if(_input.is('[type=\'checkbox\']')) {
				val = [];
				$('[name=\'' + this.name + '\']:checked').each(function() {
					val.push(this.value);
				});
			} else {
				val = this.value.trim();
			}
			if(this.name && this.name != '') {
				if(map[this.name] && map[this.name] != null) {
					if(map[this.name] instanceof Array) {
						if(val instanceof Array) {
							map[this.name] = val;
						} else {
							map[this.name].push(val);
						}
					} else {
						map[this.name] = [map[this.name], val];
					}
				} else {
					map[this.name] = val;
				}
			}
		});
		return map;
	},
	/**
	 * description：获取url参数
	 * @return {Object} 返回所有参数
	 *
	 * created by hezq on 2019-09-09
	 *
	 */
	getUrlParams () {
		// 获取url中"?"符后的字串
		let url = location.search.substr(1);
		let theRequest = {};
		let strs = url.split('&');

		for (let i = 0; i < strs.length; i++) {
			theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
		}
		return theRequest;
	},

};

export default utils;



// WEBPACK FOOTER //
// ./src/libs/utils.js